<template>
  <div>
    <Drawer title="创建AgentApp" :visible="visible" :before-close="close">
      <template v-slot:default>
        <el-form ref="form" :model="form" label-width="120px" label-position="top" :rules="rules">
          <el-form-item label="id">
            <el-input v-model="form.id"></el-input>
          </el-form-item>
          <el-form-item label="应用类型" prop="type">
            <el-radio-group v-model="form.type">
              <el-radio label="chatflow"></el-radio>
              <el-radio label="workflow"></el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="应用名称" prop="name">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="描述" prop="description">
            <el-input type="textarea" v-model="form.description"></el-input>
          </el-form-item>
        </el-form>
      </template>
      <template v-slot:footer>
        <el-button class="drawer-footer-btn" type="primary" @click="createAgentApp">保存</el-button>
        <el-button class="drawer-footer-btn" type="primary" @click="close">返回</el-button>
      </template>
    </Drawer>
  </div>
</template>

<script>
import Drawer from '@/components/drawer';
export default {
  name: 'EditAgentAppDetail',
  components: { Drawer },
  props: {
    row: { type: Object, default: () => {} },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showJson: false,
      currentJson: '',
      jsonData: '{}',
      form: {
        name: '',
        description: '',
        type: '',
        id: '',
      },
      rules: {
        name: [{ required: true, message: '请输入应用名称', trigger: 'submit' }],
        type: [{ required: true, message: '请选择应用类型', trigger: 'submit' }],
        description: [{ required: true, message: '请填写描述', trigger: 'blur' }],
      },
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        this.form = {
          name: '',
          description: '',
          type: '',
          id: '',
        };
      }
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit('close');
    },

    createAgentApp() {
      this.$refs.form.validate((valid) => {
        // valid
        console.log('%c Line:77 🥤 valid', 'color:#ffdd4d', valid);
        if (valid) {
          // createAgentApp
          this.$request({
            url: this.$api.createAgentApp,
            data: {
              agent_app: {
                ...this.form,
              },
            },
          }).then((res) => {
            console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
            // res
            console.log('%c Line:154 🥕 res', 'color:#42b983', res);
            this.$emit('refresh');
            this.close();
          });
        } else {
          this.$message.warning('请填写必填项');
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/element/button.scss';
@import '@/styles/element/form.scss';
@import '@/styles/element/radio.scss';
@import '@/styles/element/checkbox.scss';
@import '@/styles/element/input.scss';
@import '@/styles/element/select.scss';

.container {
  .row {
    margin-bottom: 8px;
    display: flex;
    .title {
      color: #98a2b2;
    }
    .text {
      flex: 1;
    }
  }
}
.drawer-footer-btn {
  margin-left: 8px;
}
.json-editor {
  background: #e5eaf2;
  height: 200px;
  overflow-x: scroll;
  overflow-y: scroll;
  cursor: pointer;
}
</style>
